export default __webpack_public_path__ + "assets/convenience.247de072.svg";